import moment from "moment";

import {
  IFlyerDetailData,
  TFlyerDetailFormat,
} from "../../../../types/flyer-detail-data/flyer-detail-data.interface";
import { FlyerDetailForm } from "./flyer-detail-form.interface";
import { Nullable } from "../../../../../../types/common";
import { isValidDate } from "../../../../../../utils/date-format.utils";

export const mapFlyerToForm = (flyer: Nullable<IFlyerDetailData>): Nullable<FlyerDetailForm> => {
  if (!flyer) {
    return null;
  }

  return {
    format: flyer.flyerFormat ?? getDefaultFlyerFormatValue(),
    id: flyer.id ?? null,
    paginationStatus: flyer.paginationStatus ? "1" : "0",
    overview: flyer.overview ?? "",
    regions: flyer.regions ?? [],
    wtwReviewDate: isValidDate(flyer.wtwReviewDate ?? "") ? moment(flyer.wtwReviewDate) : null,
    wtwSeniorReviewDate: flyer.wtwSeniorReviewDate ? moment(flyer.wtwSeniorReviewDate) : null,
    startAt: isValidDate(flyer.startAt) ? moment(flyer.startAt) : null,
    endAt: isValidDate(flyer.endAt) ? moment(flyer.endAt) : null,
  };
};

function getDefaultFlyerFormatValue(): TFlyerDetailFormat {
  return "Digital";
}
